module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [(_vm.siteNumberRequestLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', [_c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Request"
    }
  }, [(_vm.project.projectId) ? _c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }) : _vm._e(), _vm._v(" "), (_vm.investigation.investigationId) ? _c('investigationHeader', {
    attrs: {
      "investigation": _vm.investigation
    }
  }) : _vm._e(), _vm._v(" "), (_vm.siteNumberRequest.culturalResourceId && _vm.createdCrList.length > 0) ? _c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\r\n                                This Site Number Request has been approved.  Assigned Smithsonian Number(s): "), _c('strong', [_vm._v(_vm._s(_vm.createdCrSmithNos))])]) : _vm._e(), _vm._v(" "), (this.$route.params.siteNumberRequestId && (this.siteNumberRequest.projectId || this.siteNumberRequest.investigationId)) ? _c('div', {
    staticClass: "sectionHeaderRight"
  }, [(!_vm.isShpoReadOnly) ? _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "name": "newSnr"
    },
    on: {
      "click": _vm.newRequest
    }
  }, [_vm._v("New Site Number Request")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.siteNumberRequest.culturalResourceId && _vm.checkShpoRole) ? _c('div', [_c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "role": "alert"
    }
  }, [(_vm.selectedCounties.length > 1) ? _c('span', [_vm._v("There are " + _vm._s(_vm.selectedCounties.length) + " counties (" + _vm._s(_vm.selectedCounties.join(', ')) + ") in this request, multiple smithsonian numbers will be assigned if approved.")]) : _vm._e(), _vm._v(" "), (_vm.selectedCounties.length === 1) ? _c('span', [_vm._v("County in this request: " + _vm._s(_vm.selectedCounties.join(', ')))]) : _vm._e(), _vm._v(" "), (_vm.selectedCounties.length === 0) ? _c('span', [_vm._v("There are no counties in this request.")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "siteNumberRequest"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitRequest($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Request Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'has-error': _vm.errors.has('Request Type', 'siteNumberRequest')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.siteNumberRequestTypeId),
      expression: "siteNumberRequest.siteNumberRequestTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Request Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.siteNumberRequest, "siteNumberRequestTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a Request Type")]), _vm._v(" "), _vm._l((_vm.requestTypeList), function(requestType) {
    return _c('option', {
      key: requestType.requestTypeId,
      domProps: {
        "value": requestType.requestTypeId
      }
    }, [_vm._v("\r\n                                                    " + _vm._s(requestType.description) + "\r\n                                                ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Request Type', 'siteNumberRequest')),
      expression: "errors.has('Request Type', 'siteNumberRequest')"
    }],
    staticClass: "has-error"
  }, [_vm._v("\r\n                                                " + _vm._s(_vm.errors.first('Request Type', 'siteNumberRequest')) + "\r\n                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('Site Number / Site Identifier', 'siteNumberRequest')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Site Name/Site Identifier")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.siteName),
      expression: "siteNumberRequest.siteName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Site Number / Site Identifier",
      "placeholder": "Site Number / Site Identifier"
    },
    domProps: {
      "value": (_vm.siteNumberRequest.siteName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.siteNumberRequest, "siteName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Site Number / Site Identifier', 'siteNumberRequest')),
      expression: "errors.has('Site Number / Site Identifier', 'siteNumberRequest')"
    }],
    staticClass: "has-error"
  }, [_vm._v("\r\n                                                " + _vm._s(_vm.errors.first('Site Number / Site Identifier', 'siteNumberRequest')) + "\r\n                                            ")])]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteNumberRequest.siteNumberRequestTypeId === _vm.requestTypeEnum.Segment),
      expression: "siteNumberRequest.siteNumberRequestTypeId === requestTypeEnum.Segment"
    }],
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Head of Segment")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteNumberRequest.siteNumberRequestTypeId === _vm.requestTypeEnum.Segment),
      expression: "siteNumberRequest.siteNumberRequestTypeId === requestTypeEnum.Segment"
    }],
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\r\n                                            " + _vm._s(_vm.segmentHeadSiteNumber) + "\r\n                                            "), _c('a', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "font-size": "16px"
    },
    on: {
      "click": function($event) {
        _vm.showCRSelection()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('Site Description', 'siteNumberRequest')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Site Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.siteDescription),
      expression: "siteNumberRequest.siteDescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "name": "Site Description",
      "maxlength": "300",
      "placeholder": "Briefly describe the site"
    },
    domProps: {
      "value": (_vm.siteNumberRequest.siteDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.siteNumberRequest, "siteDescription", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Site Description', 'siteNumberRequest')),
      expression: "errors.has('Site Description', 'siteNumberRequest')"
    }],
    staticClass: "has-error"
  }, [_vm._v("\r\n                                                " + _vm._s(_vm.errors.first('Site Description', 'siteNumberRequest')) + "\r\n                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Collections")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.collections),
      expression: "siteNumberRequest.collections"
    }],
    attrs: {
      "type": "checkbox",
      "id": "collectionsCheckbox",
      "autocomplete": "off"
    },
    domProps: {
      "checked": Array.isArray(_vm.siteNumberRequest.collections) ? _vm._i(_vm.siteNumberRequest.collections, null) > -1 : (_vm.siteNumberRequest.collections)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.siteNumberRequest.collections,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.siteNumberRequest.collections = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.siteNumberRequest.collections = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.siteNumberRequest, "collections", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "collectionsCheckbox"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('Eligibility', 'siteNumberRequest')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Eligibility")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.eligibilityId),
      expression: "siteNumberRequest.eligibilityId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Eligibility"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.siteNumberRequest, "eligibilityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Eligible")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Not Eligible")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Unevaluated")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Eligibility', 'siteNumberRequest')),
      expression: "errors.has('Eligibility', 'siteNumberRequest')"
    }],
    staticClass: "has-error"
  }, [_vm._v("\r\n                                                " + _vm._s(_vm.errors.first('Eligibility', 'siteNumberRequest')) + "\r\n                                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Contributing Eligibility")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.contributingEligibility),
      expression: "siteNumberRequest.contributingEligibility"
    }],
    attrs: {
      "type": "checkbox",
      "autocomplete": "off",
      "id": "contributingCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.siteNumberRequest.contributingEligibility) ? _vm._i(_vm.siteNumberRequest.contributingEligibility, null) > -1 : (_vm.siteNumberRequest.contributingEligibility)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.siteNumberRequest.contributingEligibility,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.siteNumberRequest.contributingEligibility = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.siteNumberRequest.contributingEligibility = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.siteNumberRequest, "contributingEligibility", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "contributingCheckbox"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('Primary Site Type', 'siteNumberRequest')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Primary Site Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.siteNumberRequest.siteNumberRequestTypeId != _vm.requestTypeEnum.General) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.siteTypeId),
      expression: "siteNumberRequest.siteTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Primary Site Type",
      "disabled": _vm.siteNumberRequest.siteNumberRequestTypeId === _vm.requestTypeEnum.Segment
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.siteNumberRequest, "siteTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("District")])]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.siteTypeId),
      expression: "siteNumberRequest.siteTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Primary Site Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.siteNumberRequest, "siteTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.siteTypeList.filter(function (x) {
    return x.isPrimary
  })), function(siteType) {
    return _c('option', {
      key: siteType.id,
      domProps: {
        "value": siteType.id
      }
    }, [_vm._v("\r\n                                                    " + _vm._s(siteType.description) + "\r\n                                                ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Primary Site Type', 'siteNumberRequest')),
      expression: "errors.has('Primary Site Type', 'siteNumberRequest')"
    }],
    staticClass: "has-error"
  }, [_vm._v("\r\n                                                " + _vm._s(_vm.errors.first('Primary Site Type', 'siteNumberRequest')) + "\r\n                                            ")])])]), _vm._v(" "), (_vm.siteNumberRequest.siteNumberRequestTypeId == _vm.requestTypeEnum.District) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('District Ownership', 'siteNumberRequest')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("District Ownership Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.districtOwnershipTypeId),
      expression: "siteNumberRequest.districtOwnershipTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "District Ownership"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.siteNumberRequest, "districtOwnershipTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.districtOwnershipTypeList), function(type) {
    return _c('option', {
      key: type.id,
      domProps: {
        "value": type.id
      }
    }, [_vm._v("\r\n                                                    " + _vm._s(type.description) + "\r\n                                                ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('District Ownership', 'siteNumberRequest')),
      expression: "errors.has('District Ownership', 'siteNumberRequest')"
    }],
    staticClass: "has-error"
  }, [_vm._v("\r\n                                                " + _vm._s(_vm.errors.first('District Ownership', 'siteNumberRequest')) + "\r\n                                            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Secondary Site Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('checkboxPanel', {
    ref: "siteTypePanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.siteTypeList,
      "fieldName": 'siteTypeId',
      "name": "siteTypeCB"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("General Age")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row well"
  }, _vm._l((_vm.timePeriodList), function(timePeriod) {
    return _c('div', {
      key: timePeriod.index,
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedTimePeriodList),
        expression: "selectedTimePeriodList"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'timePeriod' + timePeriod.timePeriodId
      },
      domProps: {
        "value": timePeriod.timePeriodId,
        "checked": Array.isArray(_vm.selectedTimePeriodList) ? _vm._i(_vm.selectedTimePeriodList, timePeriod.timePeriodId) > -1 : (_vm.selectedTimePeriodList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedTimePeriodList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = timePeriod.timePeriodId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedTimePeriodList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedTimePeriodList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedTimePeriodList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'timePeriod' + timePeriod.timePeriodId
      }
    }, [_vm._v(_vm._s(timePeriod.description))])])])
  }))])]), _vm._v(" "), (_vm.checkShpoRole) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Skip Shape File Upload / Manual Assign County")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.skipShapeFile),
      expression: "siteNumberRequest.skipShapeFile"
    }],
    attrs: {
      "type": "checkbox",
      "autocomplete": "off",
      "id": "noShapeFileCb"
    },
    domProps: {
      "checked": Array.isArray(_vm.siteNumberRequest.skipShapeFile) ? _vm._i(_vm.siteNumberRequest.skipShapeFile, null) > -1 : (_vm.siteNumberRequest.skipShapeFile)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.siteNumberRequest.skipShapeFile,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.siteNumberRequest.skipShapeFile = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.siteNumberRequest.skipShapeFile = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.siteNumberRequest, "skipShapeFile", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "noShapeFileCb"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteNumberRequest.skipShapeFile),
      expression: "siteNumberRequest.skipShapeFile"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("County Codes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('checkboxPanel', {
    ref: "countyCodePanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.countyCodeList,
      "fieldName": 'code',
      "name": "countyCodeCB"
    }
  })], 1)]), _vm._v(" "), (_vm.siteNumberRequest.skipShapeFile) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Site Location/Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.siteNumberRequest.location),
      expression: "siteNumberRequest.location"
    }],
    staticClass: "form-control",
    attrs: {
      "row": "2",
      "name": "Site Location/Addres",
      "placeholder": "Site Location/Address"
    },
    domProps: {
      "value": (_vm.siteNumberRequest.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.siteNumberRequest, "location", $event.target.value)
      }
    }
  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Features")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('checkboxPanel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredFeatureList.length > 0),
      expression: "filteredFeatureList.length > 0"
    }],
    ref: "featurePanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.filteredFeatureList,
      "fieldName": 'featureId',
      "name": "featureCB"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Artifacts")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "row well"
  }, [_c('prehistoricArtifactSelection', {
    ref: "prehistoricArtifactSelection"
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row well"
  }, [_c('historicArtifactSelection', {
    ref: "historicArtifactSelection"
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "name": "submitButton",
      "type": "submit"
    }
  }, [_vm._v("Save")])]) : _vm._e()])], 2)]), _vm._v(" "), _c('modal', {
    ref: "segmentHeadSearch"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Cultural Resource Search")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('culturalResourceSearch', {
    attrs: {
      "addCulturalResource": _vm.setSegmentHead,
      "resultFilter": _vm.crSearchFilterSegment
    }
  })], 1)])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Files",
      "disabled": _vm.siteNumberRequest.siteNumberRequestId == null
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('media', {
    ref: "media",
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdSiteNumberRequest,
      "parentId": _vm.siteNumberRequest.siteNumberRequestId,
      "formDisabled": _vm.formDisabled,
      "shapeFileAppend": _vm.shapeFileAppendEnabled
    },
    on: {
      "shapeFileAppendSave": _vm.saveShapeFileAppend
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('hr'), _vm._v(" "), _c('mediaLetter', {
    ref: "mediaLetter",
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdSnrLetter,
      "parentId": _vm.siteNumberRequest.siteNumberRequestId
    }
  })], 1)], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Map",
      "disabled": _vm.siteNumberRequest.siteNumberRequestId == null
    }
  }, [_c('mapx', {
    ref: "mapx",
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdSiteNumberRequest,
      "parentId": _vm.siteNumberRequest.siteNumberRequestId,
      "loadOnMount": false
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Workflow",
      "disabled": _vm.siteNumberRequest.siteNumberRequestId == null
    }
  }, [(_vm.project.projectId) ? _c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('workflow', {
    ref: "workflow",
    attrs: {
      "workflowId": _vm.siteNumberRequestWorkflowId,
      "parentId": _vm.siteNumberRequest.siteNumberRequestId
    },
    on: {
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  })], 1), _vm._v(" "), (_vm.checkShpoRole) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('quickLetter', {
    attrs: {
      "projectId": _vm.project ? _vm.project.projectId : null,
      "siteNumberRequestId": _vm.siteNumberRequest.siteNumberRequestId,
      "mediaTypeId": _vm.mediaTypeIdSnrLetter,
      "parentId": _vm.siteNumberRequest.siteNumberRequestId
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Site Number Request")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34f5eea8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SiteNumberRequest.vue
// module id = 920
// module chunks = 1